export const QC_FAILURE_SUBJECT_TAGS = [
  { tag: "{{serial}}", label: "Serial number" },
  { tag: "{{plant}}", label: "Plant" },
  { tag: "{{customer}}", label: "Customer name" },
  { tag: "{{model}}", label: "Model" },
  { tag: "{{item}}", label: "Failed item" },
  { tag: "{{category}}", label: "Section" },
  { tag: "{{date}}", label: "Date" },
] as const;

export const DEFAULT_QC_FAILURE_SUBJECT = "QC failure · {{serial}} · {{plant}} · {{customer}}";

export type QcFailureSubjectFields = {
  serial?: string;
  plant?: string;
  customer?: string;
  model?: string;
  item?: string;
  category?: string;
  date?: string;
};

export function renderQcFailureSubject(template: string, fields: QcFailureSubjectFields): string {
  const source = template.trim() || DEFAULT_QC_FAILURE_SUBJECT;
  const rendered = source.replace(/\{\{\s*(serial|plant|customer|model|item|category|date)\s*\}\}/gi, (_match, key: string) => {
    const value = fields[key.toLowerCase() as keyof QcFailureSubjectFields];
    const text = typeof value === "string" ? value.trim() : "";
    return text || "—";
  });
  return rendered.replace(/\s+/g, " ").trim() || "QC failure";
}
